import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { MaterialModule } from '@modules/material.module';
import { PrimengModule } from '@modules/primeng.module';
import { MoverLancamentoDialogComponent } from '../pages/financeiro/movimentacao-caixa/components/dialogs/mover-lancamento-dialog/mover-lancamento-dialog.component';
import { TransferirLancamentoDialogComponent } from './components/transferir-lancamento-dialog/transferir-lancamento-dialog.component';
import { DialogAlteracoesNaoSalvasComponent } from './dialogs/dialog-alteracoes-nao-salvas/dialog-alteracoes-nao-salvas.component';

import { PageComponent } from './components/page/page.component';
import { PageService } from '@services//page.service';
import { MenuComponent } from '@components/menu/menu.component';
import { ListMenuComponent } from '@components/menu/list-menu/list-menu.component';
import { ItemMenuComponent } from '@components/menu/list-menu/item-menu/item-menu.component';
import { DebounceDirective } from '@directives/debounce.directive';
import { HasPermissionDirective } from '@directives/has-permission.directive';
import { DisableNoPermissionDirective } from '@directives/disable-no-permission.directive';
import { UtilsService } from '@services/utils.service';
import { LoadingModule } from '@modules/loading.module';
import { MessageComponent } from '@components/message/message.component';
import { DialogComponent } from '@components/dialog/dialog.component';
import { NumbersOnlyDirective } from '@directives/number-only.directive';
import { OverflowDetectorDirective } from '@directives/overflow-detector.directive';
import { DialogErrorComponent } from '@components/dialog-error/dialog-error.component';
import { DialogErrorService } from '@services/dialog-error.service';
import { ComboBoxComponent } from '@components/combo-box/combo-box.component';
import { DialogConfirmacaoComponent } from '@components/dialog-confirmacao/dialog-confirmacao.component';
import { ImportLancamentosService } from '@services/import-lancamentos.service';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { GenericAutocompleteComponent } from './components/generic-autocomplete/generic-autocomplete.component';
import { MenuUsuarioComponent } from '@components/menu/menu-usuario/menu-usuario.component';
import { InfoRegistroComponent } from '@components/info-registro/info-registro.component';
import { LancamentoApiService } from '@services/lancamento-api.service';


@NgModule({
  declarations: [
    MoverLancamentoDialogComponent,
    TransferirLancamentoDialogComponent,
    PageComponent,
    MenuComponent,
    ListMenuComponent,
    ItemMenuComponent,
    DebounceDirective,
    NumbersOnlyDirective,
    HasPermissionDirective,
    DisableNoPermissionDirective,
    OverflowDetectorDirective,
    MessageComponent,
    DialogComponent,
    DialogErrorComponent,
    ComboBoxComponent,
    DialogConfirmacaoComponent,
    TooltipComponent,
    GenericAutocompleteComponent,
    MenuUsuarioComponent,
    InfoRegistroComponent,
    DialogAlteracoesNaoSalvasComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    RouterModule,
    BrowserAnimationsModule,
    LoadingModule,
    PrimengModule,
    FormsModule,
  ],
  exports: [
    PageComponent,
    MenuComponent,
    DebounceDirective,
    HasPermissionDirective,
    DisableNoPermissionDirective,
    OverflowDetectorDirective,
    MessageComponent,
    DialogComponent,
    NumbersOnlyDirective,
    DialogErrorComponent,
    ComboBoxComponent,
    DialogConfirmacaoComponent,
    TooltipComponent,
    GenericAutocompleteComponent,
    InfoRegistroComponent,
    MoverLancamentoDialogComponent,
    TransferirLancamentoDialogComponent,
    DialogAlteracoesNaoSalvasComponent,
  ],
  providers: [
    PageService,
    UtilsService,
    DialogErrorService,
    ImportLancamentosService,
    LancamentoApiService,
  ]
})
export class SharedModule { }
